export class RiskUser {
  id: number;
  firstname: string;
  surname: string;
  email: string;
  admin: number;
  superAdmin: number;
  dormant: number;
  financialAccess: number;
  strategicAccess: number;
  riskEventAccess: number;
  createdAt: Date;
}
